import { memo } from "react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, Lock } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

type LoginFormData = {
  user_email: string;
  user_password: string;
};

interface LoginFormFieldsProps {
  register: UseFormRegister<LoginFormData>;
  errors: FieldErrors<LoginFormData>;
  onFocus: () => void;
}

export const LoginFormFields = memo(function LoginFormFields({ 
  register, 
  errors, 
  onFocus 
}: LoginFormFieldsProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="user_email" className="text-sm font-medium">
          {t('auth.email')}
        </Label>
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-muted-foreground" />
          <Input
            id="user_email"
            type="email"
            autoComplete="email"
            placeholder={t('auth.email')}
            {...register('user_email')}
            onFocus={onFocus}
            className="pl-10"
            data-testid="login-email-input"
          />
        </div>
        {errors.user_email && (
          <p className="mt-1 text-sm text-destructive">{errors.user_email.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="user_password" className="text-sm font-medium">
          {t('auth.password')}
        </Label>
        <div className="relative">
          <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-muted-foreground" />
          <Input
            id="user_password"
            type="password"
            autoComplete="current-password"
            placeholder={t('auth.password')}
            {...register('user_password')}
            onFocus={onFocus}
            className="pl-10"
            data-testid="login-password-input"
          />
        </div>
        {errors.user_password && (
          <p className="mt-1 text-sm text-destructive">{errors.user_password.message}</p>
        )}
      </div>
    </>
  );
});

